import api from "./api";

/**
 * Fetches the note snapshot for a customer/party
 * Returns structured data: summary, NBA, opportunities, recommendations,
 * risk factors, tags, and traits
 * 
 * @param {string} partyUuid - The UUID of the party/customer
 * @returns {Promise<Object>} The snapshot response
 */
export const getNoteSnapshot = async (partyUuid) => {
  try {
    const response = await api.post("/v1/note/snapshot", {
      party_uuid: partyUuid,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching note snapshot:", error);
    throw error;
  }
};
